import { createSlice } from '@reduxjs/toolkit';
import { CompanyDto } from '@sr/dto';
import { AsyncMeta, initialMeta } from 'shared/api/async-meta';
import { companyApi } from './api';

export type State = {
  company: CompanyDto | null;
  date: Date | null;
  meta: AsyncMeta
};

const initialState: State = {
  company: null,
  meta: initialMeta,
  date: null
};

const slice = createSlice({
  name: 'company',
  initialState: initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      companyApi.endpoints.getCompanyDetails.matchFulfilled,
      (state, { payload }) => {
        state.company = payload;
      }
    );
  }
});

export const companyReducer = slice.reducer;